import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import {WhatConnectionType} from "../../../../components/help/CommonQuestions.tsx";
import Icon from "../../../../components/selfcare/Icon.tsx";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor.tsx";
import IconArrow from "../../../../components/icons/IconArrow.tsx";

export default function TilslutEkstraudstyrArticle() {
    return (
        <>
            <article className={'help-article-content'}>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <p>
                            Ekstraudstyr som wifi-extender og wifi-mesh-systemer kan hjælpe med at sikre optimal wifi-dækning, hvis du f.eks. oplever områder i din bolig med dårlig wifi dækning.
                        </p>
                        <ul className={'list list--number'}>
                            <p>Hvis du bor i en af følgende typer bolig, er ekstraudstyr oplagt til at optimere dit wifi:</p>
                            <li>Nybyggeri med mange betonvægge.</li>
                            <li>En større villa.</li>
                            <li>Et langt etplanshus.</li>
                            <li>Rækkehus med flere etager.</li>
                        </ul>
                    </div>
                </div>

                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>
                            Sådan tilslutter du ekstraudstyr
                        </h2>
                        <p>
                            Når du har købt ekstraudstyr, kan du sætte det op på forskellige måder.
                        </p>

                        <h3>
                            Vælg dit produkt for at finde vejledning
                        </h3>
                        <div className={'button-container'}>
                            <a href={'#fiber'} className={'button button--montserrat with-icon teal'}>
                                <span className={'text'}>
                                    Jeg har fibernet eller internet via telefonstikket
                                </span>
                                <Icon component={IconArrow} className={'icon-arrow-down'}/>
                            </a>
                            <a href={'#coax'} className={'button button--montserrat with-icon teal'}>
                                <span className={'text'}>
                                    Jeg har internet via kabel-tv-stikket
                                </span>
                                <Icon component={IconArrow} className={'icon-arrow-down'}/>
                            </a>
                            <a href={'#not-sure'} className={'button button--montserrat with-icon teal'}>
                                <span className={'text'}>
                                    Jeg ved ikke, hvilket produkt jeg har
                                </span>
                                <Icon component={IconArrow} className={'icon-arrow-down'}/>
                            </a>
                        </div>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'fiber'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>Jeg har fibernet eller internet via telefonstikket</h2>
                        <ul className={'list list--number'}>
                            <p>
                                Du kan tilslutte ekstraudstyr på tre forskellige måder:
                            </p>
                            <li>
                                <p><a href={'#fiber-router'}>Opsætning via din Hiper-router</a></p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Opsætningen er simpel og let for os at supportere, hvis du en dag får brug for hjælp.
                                    </li>
                                    <li>
                                        Du kan risikere at blive ramt af double NAT (når to routere håndterer én internetforbindelse, hvilket kan forårsage problemer med f.eks. onlinespil eller port forwarding).
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p><a href={'#fiber-bridge-mode'}>Bridge mode</a></p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Ligetil og let for os at supportere, hvis du en dag får brug for hjælp.
                                    </li>
                                    <li>
                                        Ved bridge mode skal både dit ekstraudstyr og din Hiper-router være tilsluttet strøm.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p><a href={'#fiber-ont'}>Opsætning direkte i fiberboksen</a></p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Her er det kun dit eget udstyr, der skal være tilsluttet strøm- og LAN-kabel.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <p>
                            Vejledningerne herunder tager udgangspunkt i opsætning af et wifi-mesh-system med flere extenders.
                            Du kan bruge samme fremgangsmåde, hvis du kun skal tilslutte én extender.
                        </p>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'fiber-router'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h3>Opsætning via din Hiper-router</h3>
                        <div className={'text-box'}>
                            <p>
                                <strong>Fordele:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Simpel opsætning.
                                    </li>
                                </ul>
                            </p>
                            <p>
                                <strong>Ulemper:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Både Hiper-routeren og ekstraudstyret skal bruge strøm.
                                    </li>
                                    <li>
                                        Risiko for double NAT
                                        (når to routere håndterer én internetforbindelse, hvilket kan forårsage problemer med f.eks. onlinespil og port forwarding).
                                    </li>
                                </ul>
                            </p>
                        </div>
                        <ul className={'list list--number'}>
                            <li>
                                Sæt et LAN-kabel i LAN-porten på den primære extender og i en vilkårlig LAN-port i Hiper-routeren.
                            </li>
                            <li>
                                Nu opretter den primære extender forbindelse til din router.
                            </li>
                            <li>
                                <p>
                                    Du kan placere de andre extenders i din bolig.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>Tjek mesh-systemets brugsanvisning for vejledning til at placere dem.</li>
                                    <li>
                                        Du kan også lære vores <Link to={'/hjaelp/internet-og-wifi/placering-af-router'}>tips til at placere en router optimalt</Link>{' '}
                                        &ndash; vi anbefaler at du placerer dine extenders på samme måde.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Nu er dit mesh-system opsat.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Dit nye wifi-navn og -kode står ofte på bagsiden af dit mesh-system.
                                    </li>
                                    <li>
                                        Nogle wifi-mesh-systemer duplikerer dit nuværende wifi-navn og -kode.
                                        Vi anbefaler, at du tjekker brugsanvisningen til mesh-systemet.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Deaktivér wifi på Hiper-routeren ved at trykke på &ldquo;WiFi ON/OFF&rdquo; på bagsiden af Hiper-routeren.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        2.4- og 5 GHz-lampen stopper med at lyse.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'fiber-bridge-mode'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h3>Opsætning via Hiper-router i bridge mode</h3>
                        <div className={'text-box'}>
                            <p>
                                <strong>Fordele:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Simpel opsætning.
                                    </li>
                                    <li>
                                        Maksimal udnyttelse af ekstraudstyret.
                                    </li>
                                </ul>
                            </p>
                            <p>
                                <strong>Ulemper:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Både Hiper-routeren og ekstraudstyret skal bruge strøm.
                                    </li>
                                </ul>
                            </p>
                        </div>
                        <ul className={'list list--number'}>
                            <li>
                                <p>
                                    Først skal du sætte Hiper-routeren i bridge mode.
                                    Følg <Link to={'/hjaelp/udstyr/bridge-mode'}>bridge mode-guiden her</Link>.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Når Hiper-routeren er i bridge mode, er den inaktiv og dens eneste formål er lade trafikken passere videre, ligesom et kabel.
                                    </li>
                                    <li>
                                        Du kan ikke længere bruge Hiper-routerens wifi og interface.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Sæt et LAN-kabel i LAN-porten på den primære extender og i en vilkårlig LAN-port i Hiper-routeren.
                            </li>
                            <li>
                                Den primære extender opretter nu forbindelse til din router.
                            </li>
                            <li>
                                <p>
                                    Nu kan du placere de andre extenders i din bolig.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>Tjek mesh-systemets brugsanvisning for vejledning til at placere dem.</li>
                                    <li>
                                        Du kan også lære vores <Link to={'/hjaelp/internet-og-wifi/placering-af-router'}>tips til at placere en router optimalt</Link>{' '}
                                        &ndash; vi anbefaler at du placerer dine extenders på samme måde.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Nu er dit mesh-system opsat.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Hvis du vil forlade bridge mode, kan du nulstille routeren ved at trykke et spidst objekt ind i &ldquo;RESET&rdquo; bag på routeren.
                                        Så bliver routeren gendannet til fabriksindstillinger, og du kan bruge wifi-navnet og -koden der står bag på routeren.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'fiber-ont'} className={'id-anchor--help'}/>
                <div className={'article article'}>
                    <div className={'paragraph'}>
                        <h3>Opsætning direkte i fiberboks</h3>
                        <div className={'text-box'}>
                            <p>
                                <strong>Fordele:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Færre kabler.
                                    </li>
                                    <li>
                                        Maksimal udnyttelse af ekstraudstyret.
                                    </li>
                                </ul>
                            </p>
                            <p>
                                <strong>Ulemper:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Komplekst at sætte op.
                                    </li>
                                </ul>
                            </p>
                        </div>
                        <ul className={'list list--number'}>
                            <li>
                                Først skal du VLAN-tagge Hiper-routeren.
                                Følg <Link to={'/hjaelp/udstyr/vlan-tagging'}>VLAN-tagging-guiden her</Link>.
                            </li>
                            <li>
                                Når Hiper-routeren er VLAN-tagget, skal du sætte et LAN-kabel i LAN-porten på den primære extender og i den aktive port i fiberboksen.
                            </li>
                            <li>
                                Den primære extender opretter nu forbindelse til din router.
                            </li>
                            <li>
                                <p>
                                    Nu kan du placere de andre extenders i din bolig.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>Tjek mesh-systemets brugsanvisning for vejledning til at placere dem.</li>
                                    <li>
                                        Du kan også lære vores <Link to={'/hjaelp/internet-og-wifi/placering-af-router'}>tips til at placere en router optimalt</Link>{' '}
                                        &ndash; vi anbefaler at du placerer dine extenders på samme måde.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Nu er dit mesh-system klar til brug.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Dit nye wifi-navn og -kode vil typisk stå på bagsiden af dit mesh-system.
                                    </li>
                                    <li>
                                        Nogle wifi-mesh-systemer duplikerer dit nuværende wifi-navn og -kode.
                                        Vi anbefaler, at du tjekker brugsanvisningen til mesh-systemet.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'coax'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>Jeg har internet via kabel-tv-stikket</h2>
                        <ul className={'list list--number'}>
                            <p>
                                Der er to måder at sætte ekstraudstyr til din Hiper-router på:
                            </p>
                            <li>
                                <p><a href={'#coax-router'}>Opsætning via din Hiper-router, hvor du deaktiverer wifi på den</a></p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Opsætningen er simpel, dog risikerer du at blive ramt af double NAT (når to routere håndterer én internetforbindelse, hvilket kan forårsage problemer med f.eks. onlinespil og port forwarding).
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p><a href={'#coax-bridge-mode'}>Opsætning via din Hiper-router i bridge mode</a></p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Opsætningen er simpel og let for os at supportere, hvis du en dag får brug for hjælp.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <p>
                            Vejledningerne herunder tager udgangspunkt i opsætning af et wifi-mesh-system med flere extenders.
                            Du kan bruge samme fremgangsmåde, hvis du kun skal tilslutte én extender.
                        </p>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'coax-router'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h3>Opsætning via Hiper-router, hvor du deaktiverer wifi</h3>
                        <div className={'text-box'}>
                            <p>
                                <strong>Fordele:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Nem opsætning.
                                    </li>
                                </ul>
                            </p>
                            <p>
                                <strong>Ulemper:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Både Hiper-routeren og ekstraudstyret skal bruge strøm.
                                    </li>
                                    <li>
                                        Risiko for double NAT
                                        (når to routere håndterer én internetforbindelse, hvilket kan forårsage problemer med f.eks. onlinespil og port forwarding).
                                    </li>
                                </ul>
                            </p>
                        </div>
                        <ul className={'list list--number'}>
                            <li>
                                Sæt et LAN-kabel i LAN-porten på den primære extender og i en vilkårlig LAN-port i Hiper-routeren.
                            </li>
                            <li>
                                Den primære extender opretter nu forbindelse til din router.
                            </li>
                            <li>
                                <p>
                                    Nu kan du placere de resterende extenders i din bolig.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>Tjek mesh-systemets brugsanvisning for vejledning til at placere dem.</li>
                                    <li>
                                        Du kan også lære vores <Link to={'/hjaelp/internet-og-wifi/placering-af-router'}>tips til at placere en router optimalt</Link>{' '}
                                        &ndash; vi anbefaler at du placerer dine extenders på samme måde.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Nu er dit mesh-system klar til brug.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Dit nye wifi-navn og -kode står ofte på bagsiden af dit mesh-system.
                                    </li>
                                    <li>
                                        Nogle wifi-mesh-systemer duplikerer dit nuværende wifi-navn og -kode.
                                        Vi anbefaler, at du tjekker brugsanvisningen til mesh-systemet.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'coax-bridge-mode'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h3>Opsætning via Hiper-router i bridge mode</h3>
                        <div className={'text-box'}>
                            <p>
                                <strong>Fordele:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Simpel opsætning.
                                    </li>
                                    <li>
                                        Maksimal udnyttelse af ekstraudstyret.
                                    </li>
                                </ul>
                            </p>
                            <p>
                                <strong>Ulemper:</strong>
                                <ul className="list list--bullet">
                                    <li>
                                        Både Hiper-routeren og ekstraudstyret skal bruge strøm.
                                    </li>
                                </ul>
                            </p>
                        </div>
                        <ul className={'list list--number'}>
                            <li>
                                <p>
                                    Først skal du sætte Hiper-routeren i bridge mode.
                                    Følg <Link to={'/hjaelp/udstyr/bridge-mode'}>bridge mode-guiden her</Link>.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Når Hiper-routeren er i bridge mode, er den inaktiv og dens eneste formål er lade trafikken passere videre, ligesom et kabel.
                                    </li>
                                    <li>
                                        Du kan ikke længere bruge Hiper-routerens wifi og interface.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Når Hiper-routeren er i bridge mode, skal du sætte et LAN-kabel i LAN-porten på den primære extender og i en vilkårlig LAN-port i Hiper-routeren.
                            </li>
                            <li>
                                Den primære extender opretter nu forbindelse til din router.
                            </li>
                            <li>
                                <p>
                                    Nu kan du placere de resterende extenders i din bolig.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>Tjek mesh-systemets brugsanvisning for vejledning til at placere dem.</li>
                                    <li>
                                        Du kan også lære vores <Link to={'/hjaelp/internet-og-wifi/placering-af-router'}>tips til at placere en router optimalt</Link>{' '}
                                        &ndash; vi anbefaler at du placerer dine extenders på samme måde.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Nu er dit mesh-system klar til brug.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        Dit nye wifi-navn og -kode står ofte på bagsiden af dit mesh-system.
                                    </li>
                                    <li>
                                        Nogle wifi-mesh-systemer duplikerer dit nuværende wifi-navn og -kode. Vi anbefaler, at du tjekker brugsanvisningen til mesh-systemet.
                                    </li>
                                    <li>
                                        <p>
                                            Hvis du vil forlade bridge mode, kan du nulstille routeren ved at trykke et spidst objekt ind &ldquo;RESET&rdquo; bag på routeren.
                                        </p>
                                        <p>
                                            Så bliver routeren gendannet til fabriksindstillinger, og du kan bruge wifi-navnet og -koden, der står bag på routeren.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'not-sure'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>{WhatConnectionType.question}</h2>
                        {WhatConnectionType.answer}
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        category: "udstyr",
                        article: "kan-jeg-bruge-mit-eget-udstyr",
                        name: "Kan jeg bruge mit eget udstyr?"
                    },
                    {
                        category: "udstyr",
                        article: "bridge-mode",
                        name: "Guide til Bridge Mode"
                    },
                    {
                        category: "udstyr",
                        article: "vlan-tagging",
                        name: "Guide til VLAN-tagging"
                    },
                    {
                        category: "internet-og-wifi",
                        article: "placering-af-router",
                        name: "Hvor er det bedst at placere min router?"
                    }
                ]}
            />
        </>
    )
}
